import { Component, Input, OnInit, Inject } from '@angular/core';
import { ContactMethod, ContactMethodDisplayOptions } from '../models/contact-method.model';

@Component({
  selector: 'contact-method',
  styles: [require('./contact-method.component.scss')],
  template: require('./contact-method.component.html') ,
})

export class ContactMethodComponent implements OnInit {
  @Input() contactMethod: ContactMethod;
  @Input() showIcon: boolean = true;
  @Input() numberDisplay: ContactMethodDisplayOptions = 'inline';
  @Input() splittedDisplay: boolean = false;
  private kind: any;

  constructor(
    @Inject('$translate') public $translate,
  ) {}

  ngOnInit() {
    if (this.contactMethod.kind.mnemonic) {
      this.kind = this.contactMethod.kind.mnemonic;
    } else {
      this.kind = this.contactMethod.kind;
    }
  }
}




// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/contact-method/contact-method.component.ts